// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName


import { application } from "./application"

import Password from "./password_controller.js"
application.register("password", Password)

import TurboDialog from "./turbo_dialog_controller.js"
application.register("turbo-dialog", TurboDialog)

import ImageUpload from "./image_upload_controller.js"
application.register("image-upload", ImageUpload)

import Dialog from "./dialog_controller.js"
application.register("dialog", Dialog)

import ElementRemoval from "./element_removal_controller.js"
application.register("element-removal", ElementRemoval)

import Theme from "./theme_controller.js"
application.register("theme", Theme)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import TextareaAutogrow from 'stimulus-textarea-autogrow'
application.register('textarea-autogrow', TextareaAutogrow)

import DropzoneController from '@kanety/stimulus-dropzone';
application.register('dropzone', DropzoneController);

import Dropdown from './dropdown_controller.js'
application.register('dropdown', Dropdown)

import ToggleVisibility from "./toggle_visibility_controller.js"
application.register("toggle-visibility", ToggleVisibility)
